import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { SCENTS } from "@/config";

export const Scents = ({ selected, onSelect }) => (
  <section id="scents" className="py-20 md:py-28">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <Reveal className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brandTerracotta">
          The Scent Collection
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl font-bold mt-3">Choose your ritual</h2>
        <p className="text-brandDarkSlate/75 mt-3 text-sm sm:text-base">
          Four botanical blends, hand-poured into our signature perforated jars. Pick the mood you want to come home
          to.
        </p>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SCENTS.map((s, i) => {
          const active = selected?.id === s.id;
          return (
            <Reveal key={s.id} delay={i * 0.12} className="h-full">
              <motion.article
                data-testid={`scent-card-${s.id}`}
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 250, damping: 20 }}
                className={`relative h-full bg-white p-8 rounded-2xl border shadow-sm hover:shadow-xl hover:shadow-brandTerracotta/10 transition-shadow space-y-4 ${
                  active ? "border-brandTerracotta ring-1 ring-brandTerracotta/40" : "border-brandSand"
                }`}
              >
                {s.tag && (
                  <span className="absolute top-5 right-5 text-[10px] uppercase tracking-[0.2em] font-bold bg-brandSand text-brandTerracotta px-3 py-1 rounded-full">
                    {s.tag}
                  </span>
                )}
                <div className="relative aspect-[4/3] -mx-8 -mt-8 mb-2 overflow-hidden rounded-t-2xl">
                  <img
                    data-testid={`scent-img-${s.id}`}
                    src={s.img}
                    alt={`${s.name} — Enchanted Glim soy wax candle`}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                  />
                </div>
                <h3 className="font-serif text-2xl font-bold">{s.name}</h3>
                <p className="text-sm font-medium text-brandTerracotta">{s.benefit}</p>
                <p className="text-sm text-brandDarkSlate/70 leading-relaxed">{s.notes}</p>
                <motion.a
                  data-testid={`scent-select-${s.id}`}
                  href="#order-calculator"
                  onClick={() => onSelect(s)}
                  whileTap={{ scale: 0.96 }}
                  className={`inline-flex items-center gap-2 text-sm font-semibold px-5 py-2.5 rounded-full transition-colors ${
                    active
                      ? "bg-brandTerracotta text-white"
                      : "border border-brandDarkSlate/20 hover:bg-brandSand"
                  }`}
                >
                  {active ? "Selected" : `Choose ${s.name}`}
                </motion.a>
              </motion.article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
